module.exports = __webpack_public_path__ + "static/media/favicon.fd611e6e.ico";